import axios from 'axios';

const ENDPOINTS_API_URL = `${process.env.REACT_APP_API_BASE_URL || 'https://api.piosphere.ai'}/agent-manager/public/v1/endpoints`;
const FALLBACK_ENDPOINTS = (process.env.REACT_APP_FALLBACK_ENDPOINTS_BASE || 'chatbot.piosphere.ai')
  .split(',')
  .map(endpoint => endpoint.trim());

let cachedEndpoints = null;
let lastFetchTime = null;
const CACHE_DURATION = parseInt(process.env.REACT_APP_ENDPOINTS_CACHE_DURATION) || 300000;

export const fetchEndpoints = async () => {
  const now = Date.now();
  
  if (cachedEndpoints && lastFetchTime && (now - lastFetchTime) < CACHE_DURATION) {
    return cachedEndpoints;
  }

  try {
    const response = await axios.get(ENDPOINTS_API_URL, {
      timeout: 10000
    });

    if (response.status === 200 && response.data.endpoints) {
      cachedEndpoints = {
        endpoints: response.data.endpoints,
        nodes: response.data.nodes || {}
      };
      lastFetchTime = now;
      return cachedEndpoints;
    }
    
    console.warn('Invalid response from endpoints API, using fallback endpoints');
    return { endpoints: FALLBACK_ENDPOINTS, nodes: {} };
  } catch (error) {
    console.error('Failed to fetch endpoints:', error);
    return { endpoints: FALLBACK_ENDPOINTS, nodes: {} };
  }
};

export const getEndpoints = async () => {
  const result = await fetchEndpoints();
  return result.endpoints;
};

export const getNodeInfo = async (endpoint) => {
  const result = await fetchEndpoints();
  return result.nodes[endpoint] || null;
};

export const clearEndpointsCache = () => {
  cachedEndpoints = null;
  lastFetchTime = null;
};

export const checkEndpointHealth = async (endpoint) => {
  try {
    const response = await axios.get(`https://${endpoint}`, {
      timeout: 5000
    });

    if (response.status === 200 || response.status === 404) {
      return true;
    }
    return false;
  } catch (error) {
    if (error.code === 'ECONNREFUSED' || error.code === 'ETIMEDOUT') {
      console.warn(`Endpoint ${endpoint} is not reachable:`, error.message);
      return false;
    }
    
    if (error.response && (error.response.status === 200 || error.response.status === 404 || error.response.status === 403)) {
      return true;
    }
    
    console.warn(`Health check failed for ${endpoint}:`, error.message);
    return false;
  }
};

